import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteVarietal = async (varietalId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/varietal/${varietalId}`);
  return res.data;
};

export default deleteVarietal;
